// extracted by mini-css-extract-plugin
export var label = "_cn-1";
export var reminder = "_cn-0";